import moment from "moment";

// eslint-disable-next-line import/prefer-default-export
export const getFormateDate = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
